import classNames from "classnames";
import React,{ FC, useEffect, useState } from "react";
import {RightOutline} from "antd-mobile-icons"
import styles from "./index.module.less";
import { useDocumentTitle } from "~src/hooks/useDocumentTitle";
import { InvoiceDetailType } from "~src/service/bill/bill";
import { getInvoiceDetail } from "~src/service/bill";
import useQuery from "~src/hooks/useQuery";
import { useNavigate } from "react-router-dom";


const BillDetails: FC = () => {
  useDocumentTitle('开票详情')
  const navigate = useNavigate()
  const searchQuery = useQuery()
  const id = searchQuery("id")
  const biz = searchQuery("biz")
  const [details, setDetails] = useState<InvoiceDetailType>({} as InvoiceDetailType)
  const pullDetails = async () => {
    const data = await getInvoiceDetail({bizName: biz, outInvoiceId: id as string})
    setDetails(data)
  }
  useEffect(() => {
    pullDetails()
  }, [])
  const statusText = (status: any) =>{
    switch (status) {
      case 0:
        return "开票中"
      case 1:
        return "开票成功"
      case 2:
        return "开票失败"
      default:
        break;
    }
  }
  const onRelated = () => {
    navigate(`/bill/related?id=${details.outInvoiceId}&biz=${biz}`)
  }
  const onPreview = () => {
    navigate(`/bill/previe?id=${details.outInvoiceId}&biz=${biz}`)
  }
  return <div>
    <div className={styles["details-topbg"]}></div>
    <div className={styles["details-content"]}>
      <div className={styles["details-content-title"]}>发票信息</div>
      <div className={classNames(styles.card, styles["card-box"])}>
        <div className={styles["card-item"]}>
          <div className={styles["card-item-lable"]}>当前状态</div>
          <div>{statusText(details.status)}</div>
        </div>
        <div className={styles["card-item"]}>
          <div className={styles["card-item-lable"]}>申请时间</div>
          <div>{details.createdAt}</div>
        </div>
        <div className={styles["card-item"]}>
          <div className={styles["card-item-lable"]}>发票业务</div>
          <div>{details.title}</div>
        </div>
        <div className={styles["card-item"]}>
          <div className={styles["card-item-lable"]}>发票金额</div>
          <div>¥{details.totalAmount}</div>
        </div>
      </div>
      <div className={styles.card}>
        <div className={styles["card-item"]}>
          <div className={styles["card-item-lable"]}>发票类型</div>
          <div>{details.invoiceType === 1 ? "增值税普通电子发票": "增值税专用电子发票"}</div>
        </div>
        <div className={styles["card-item"]}>
          <div className={styles["card-item-lable"]}>抬头类型</div>
          <div>{details.businessType === 1 ? "个人": "企业"}</div>
        </div>
        <div className={styles["card-item"]}>
          <div className={styles["card-item-lable"]}>发票抬头</div>
          <div>{details.invoiceTitle}</div>
        </div>
        <div className={styles["card-item"]}>
          <div className={styles["card-item-lable"]}>收件邮箱</div>
          <div>{details.payerEmail}</div>
        </div>
      {
       details.businessType === 2 &&  <>
         <div className={styles["card-item"]}>
             <div className={classNames(styles["card-item-lable"], styles["card-item-right"])}>纳税人识别号</div>
             <div>{details.payerRegisterNo}</div>
           </div>
           <div className={styles["card-item"]}>
             <div className={styles["card-item-lable"]}>开户银行</div>
             <div>{details.bankName}</div>
           </div>
           <div className={styles["card-item"]}>
             <div className={styles["card-item-lable"]}>银行账户</div>
             <div>{details.account}</div>
           </div>
           <div className={styles["card-item"]}>
             <div className={styles["card-item-lable"]}>企业地址</div>
             <div>{details.companyAddress}</div>
           </div>
           <div className={styles["card-item"]}>
             <div className={styles["card-item-lable"]}>企业电话</div>
             <div>{details.companyPhone}</div>
           </div>
        </>
      }
      </div>
      <div className={classNames(styles.list, styles["list-top"])}>
        <div className={styles["list-label"]}>关联订单</div>
        <div className={styles["list-value"]} onClick={onRelated}>
          <span>{details.orderCount}笔订单</span>
          <RightOutline className={styles["list-value-icon"]} fontWeight={800}/>
        </div>
      </div>
      <div className={classNames(styles.list, styles["list-bottom"])} onClick={onPreview}>
        <div className={styles["list-label"]}>发票预览</div>
        <div className={styles["list-value"]}>
          {/* <span>2笔订单</span> */}
          <RightOutline className={styles["list-value-icon"]} fontWeight={800}/>
        </div>
      </div>
    </div>
  </div>
}
export default BillDetails